var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-mapbox-map__overlay",
      class: { "c-mapbox-map__overlay--disabled": _vm.disabled },
      on: {
        click: function ($event) {
          $event.preventDefault()
          _vm.disabled = true
        },
      },
    },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inner" }, [
      _c("a", { staticClass: "btn-main", attrs: { href: "#" } }, [
        _vm._v("Click to Explore Map"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./Assets/Scripts/Components/Mapbox/overlay/overlay.vue?vue&type=template&id=48114a76&
// module id = 414
// module chunks = 1